import { render, staticRenderFns } from "./Inputdata.vue?vue&type=template&id=b09a5e48&"
import script from "./Inputdata.vue?vue&type=script&lang=js&"
export * from "./Inputdata.vue?vue&type=script&lang=js&"
import style0 from "./Inputdata.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports